module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/landing/mobile-66218a8f7a727ec978083d9d34b00f1a.jpg";